import * as React from "react";
import {INPUT_TYPE, StyleType} from "utils/variables";
import {FIELD_NAMES} from "profile/enums";
import {TextField} from "web-com";
import {IReferenceDetails, IReferences} from "IncompleteInfoV2/References";
import {mobileNumberLength} from "IncompleteInfoV2/utils";

interface IProps {
    profile: IReferences;
    errors?: IReferenceDetails[];
    onChange: (fieldName: string, value: string, index: number) => void;
}

export const ReferencesFields = (props: IProps) => {
    const handleFamilyReferenceChange = (fieldName: string, value: string) => {
        props.onChange(fieldName, value, 0);
    };

    const handleFriendReferenceChange = (fieldName: string, value: string) => {
        props.onChange(fieldName, value, 1);
    };
    return <div className="reference-fields-container">
        <TextField
            type={INPUT_TYPE.TEXT}
            label="Family Reference Name"
            value={props.profile[FIELD_NAMES.REFERENCES][0][FIELD_NAMES.REFERENCE_NAME]}
            fieldName={FIELD_NAMES.REFERENCE_NAME}
            onChange={handleFamilyReferenceChange}
            placeholder="Please enter reference name"
            errorMsg={(props.errors && props.errors[0][FIELD_NAMES.REFERENCE_NAME]) || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT} />
        <TextField
            type={INPUT_TYPE.NUMBER}
            label="Family Reference Mobile"
            value={props.profile[FIELD_NAMES.REFERENCES][0][FIELD_NAMES.REFERENCE_MOBILE]}
            fieldName={FIELD_NAMES.REFERENCE_MOBILE}
            placeholder="Please enter reference mobile number"
            onChange={handleFamilyReferenceChange}
            errorMsg={(props.errors && props.errors[0][FIELD_NAMES.REFERENCE_MOBILE]) || null}
            max={mobileNumberLength}
            styleType={StyleType.BORDER_BOTTOM_INPUT} />
        <TextField
            type={INPUT_TYPE.TEXT}
            label="Friend Reference Name"
            value={props.profile[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_NAME]}
            fieldName={FIELD_NAMES.REFERENCE_NAME}
            placeholder="Please enter reference name"
            onChange={handleFriendReferenceChange}
            errorMsg={(props.errors && props.errors[1][FIELD_NAMES.REFERENCE_NAME]) || null}
            styleType={StyleType.BORDER_BOTTOM_INPUT} />
        <TextField
            type={INPUT_TYPE.NUMBER}
            label="Friend Reference Mobile"
            value={props.profile[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_MOBILE]}
            fieldName={FIELD_NAMES.REFERENCE_MOBILE}
            placeholder="Please enter reference mobile number"
            onChange={handleFriendReferenceChange}
            errorMsg={(props.errors && props.errors[1][FIELD_NAMES.REFERENCE_MOBILE]) || null}
            max={mobileNumberLength}
            styleType={StyleType.BORDER_BOTTOM_INPUT} />
    </div>;
};

export default ReferencesFields;
